<template>
  <b-container>
    <div class="py-3 bg-white text-center licensed-certified">
      <h1 class="font-weight-bold mb-3">Licensed & Certified</h1>
      <p class="mt-2 text-muted">
        Our credentials and certifications ensure you receive professional,
        safe, and reliable <br />
        garage door service every time.
      </p>
      <div class="d-flex flex-wrap justify-content-around mt-4">
        <span class="badge badge-pill border m-1 px-3 py-2"
          >Licensed & Insured</span
        >
        <span class="badge badge-pill border m-1 px-3 py-2"
          >Better Business Bureau A+</span
        >
        <span class="badge badge-pill border m-1 px-3 py-2"
          >IDEA Certified Technicians</span
        >
        <span class="badge badge-pill border m-1 px-3 py-2"
          >Overhead Door Authorized Dealer</span
        >
        <span class="badge badge-pill border m-1 px-3 py-2"
          >Commercial Door Institute Member</span
        >
      </div>

      <div class="mt-5 bg-primaryblue text-white rounded-xlg shadow p-4 p-md-3">
        <h3 class="font-weight-bold my-4">Why Choose Us?</h3>
        <div class="row">
          <div class="col-md-4 mb-4 mb-md-0">
            <div class="d-flex flex-column align-items-center hover-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="none"
                stroke="white"
                stroke-width="2"
                viewBox="0 0 24 24"
                class="mb-3"
              >
                <path
                  d="M12 2L3 5v6c0 5.5 3.8 10.7 9 12 5.2-1.3 9-6.5 9-12V5l-9-3z"
                />
              </svg>
              <h5 class="font-weight-bold">Fully Insured</h5>
              <p class="mt-2">
                Comprehensive liability and workers compensation insurance
              </p>
            </div>
          </div>

          <div class="col-md-4 mb-4 mb-md-0">
            <div class="d-flex flex-column align-items-center hover-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="none"
                stroke="white"
                stroke-width="2"
                viewBox="0 0 24 24"
                class="mb-3"
              >
                <circle cx="12" cy="8" r="5" />
                <path d="M8.5 21h7l-3.5-6z" />
              </svg>
              <h5 class="font-weight-bold">Certified Technicians</h5>
              <p class="mt-2">Ongoing training and industry certifications</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="d-flex flex-column align-items-center hover-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="none"
                stroke="white"
                stroke-width="2"
                viewBox="0 0 24 24"
                class="mb-3"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>
              <h5 class="font-weight-bold">Trusted Technicians</h5>
              <p class="mt-2">Comprehensive warranty on labor</p>
            </div>
          </div>
        </div>

        <!-- Call Btn -->
        <div class="my-4">
          <a href="tel:5514080587" class="btn btn-light font-weight-bold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="none"
              stroke="#0d47a1"
              stroke-width="2"
              viewBox="0 0 24 24"
              class="mr-2 mb-1"
            >
              <path
                d="M22 16.92v3a2 2 0 0 1-2.18 2c-3.2-.3-6.26-1.7-8.63-4.07C8.82 15.5 7.42 12.43 7.12 9.24a2 2 0 0 1 2-2h3c.6 0 1.1.4 1.2 1l.3 2c.1.6-.1 1.2-.6 1.6l-1.2.9c1.1 2.1 2.9 3.9 5 5l.9-1.2c.4-.5 1-.7 1.6-.6l2 .3c.6.1 1 .6 1 1.2z"
              />
            </svg>
            Call (551) 408-0587
          </a>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "LicensedCertifiedSection",
};
</script>

<style scoped>
.rounded-xlg {
  border-radius: 1rem;
}
.bg-primaryblue {
  background-color: #0d47a1 !important;
}
.badge-pill {
  transition: all 0.3s ease;
  cursor: pointer;
}
.badge-pill:hover {
  background-color: #0d47a1;
  border-color: #0d47a1;
  color: white;
  transform: scale(1.05);
}
@media (max-width: 768px) {
  h1 {
    font-size: 30px;
  }
}
</style>
